import { Theme } from "@mui/material";

const settingsStyles = (theme: Theme) => {
  return {
    centerItem: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    labelBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      pb: 0.5,
    },
    inputLabel: {
      color: "#475569",
      fontWeight: 600,
      fontSize: "14px",
      marginLeft: "5px !important",
    },
    chip: {
      maxHeight: "28px",
      ml: 1,
      mt: 1,
      borderRadius: "5px",
      "&.MuiChip-root ": {
        opacity: 1,
      },
      "&.MuiChip-label ": {
        color: "#91949C",
      },
      "&.css-15ka1ix-MuiButtonBase-root-MuiChip-root .MuiChip-deleteIcon": {},
    },
    nameField: {
      textTransform: "capitalize",
      "& .MuiFormLabel-asterisk": {
        color: "red",
      },
    },
    select: {
      borderRadius: "8px !important",
      "&.MuiSelect-root": {
        borderRadius: "8px !important",
      },
      "& .MuiInputBase-input": {
        padding: "9px 13px",
      },
      ".MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator": {
        color: "green",
      },
      marginTop: "8px !important",
    },
    errorStyling: {
      paddingLeft: "14px",
    },
    placeholderText: {
      color: "#999",
    },
    selectedChip: {
      maxHeight: "28px",
      borderRadius: "10px",
      "&.MuiChip-root ": {
        backgroundColor: "#7551D014",
        opacity: 1,
      },
      "&.MuiChip-label ": {
        color: "black",
      },
      "&.css-15ka1ix-MuiButtonBase-root-MuiChip-root .MuiChip-deleteIcon": {
        color: "black",
      },
      "&:not(:first-child)": {
        ml: 1,
      },
    },
    card: {
      border: "1px solid #F0F0F0",
      borderRadius: "10px",
      boxShadow: 0,
    },
    optionStyle: {
      // ...regularFont,
    },
    checkbox: {
      "&.Mui-checked": {
        color: "#415A38",
      },
    },
    deleteButton: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 4,
      padding: "5px 0px",
      cursor: "pointer",
    },
    dropzone: {
      width: "7.8rem",
      height: "7.8rem",
      position: "absolute",
      left: "-1%",
      top: "-1%",
      zIndex: "1",
      border: "none",
      borderRadius: "50%",
    },
    dropzoneInnerBox: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      opacity: 0,
      borderRadius: "50%",
      transition: "all 0.3s ease-in-out",
      "&:hover": {
        opacity: 1,
        background: "#2121218c",
        cursor: "pointer",
      },
    },
    dropzoneTextStyles: {
      color: "white",
      fontSize: "0.8rem",
      textAlign: "center",
      width: "100%",
    },
    viewModeBtn: {
      color: "#111927",
      backgroundColor: "#e2e3e5",
      padding: "5px 15px",
      "&:hover": {
        backgroundColor: "#cfcfcf",
      },
    },
    viewModeBtnDark: {
      color: "#ffffff",
      backgroundColor: "#444444",
      padding: "5px 15px",
      "&:hover": {
        backgroundColor: "#373737",
      },
    },
    dropDown: {
      width: "100%",
      backgroundColor: "#FFFFFF",
      "& .MuiOutlinedInput-input": {
        padding: "0px !important",
      },
      "& .MuiSelect-outlined": {
        color: "#475569",
        fontWeight: 600,
      },
      "&:hover": {
        background: "transparent",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: 0,
      },
      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
        border: 0,
      },
      "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: 0,
      },
    },
    dropDownMenuItem: {
      "&:not(:last-child)": {
        borderBottom: "1px solid #e0e0e0",
      },
      "&.Mui-selected": {
        backgroundColor: "#FFFFFF",
        color: theme.palette.primary.main,
        fontWeight: 500,
      },
      "&:focus": { backgroundColor: "#FFFFFF" },
    },
    textField: {
      fontSize: "16px",
      "& .MuiInputBase-input": {
        padding: "10px 8px",
      },
      "& .MuiInput-underline:before": {
        borderBottom: "1px solid #47556940 !important",
      },
      "& .MuiInput-underline:hover:before": {
        borderBottom: "1px solid #47556940 !important",
      },
      "& .MuiInput-underline:after": {
        borderBottom: "1px solid #7551D0 !important",
      },
    },
  };
};

export default settingsStyles;
